"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerContact = void 0;
const typeorm_1 = require("typeorm/browser");
let CustomerContact = class CustomerContact {
};
__decorate([
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 255,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "apiId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 18,
        name: 'accountid',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "accountId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        default: '',
        length: 40,
        name: 'salutation',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "salutation", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 40,
        name: 'firstname',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "firstName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'lastname',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'email',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 40,
        name: 'phone',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "phone", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 40,
        name: 'mobilephone',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "mobilePhone", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'use_as__c',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "useAs", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'language__c',
    }),
    __metadata("design:type", String)
], CustomerContact.prototype, "language", void 0);
CustomerContact = __decorate([
    (0, typeorm_1.Entity)('contact', { schema: 'public', synchronize: false })
], CustomerContact);
exports.CustomerContact = CustomerContact;
//# sourceMappingURL=customer-contact.js.map